/**
 * accept-button.js
 */

import React from 'react';
import { Tooltip, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Icon from 'components/icon';


const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 'auto',
    marginRight: theme.spacing(1),
  },
}));


export default function AcceptButton(props) {
  const { onClick, disabled } = props;
  const classes = useStyles();
  return (
    <>
      <Tooltip arrow placement='top' title='Accept this request'>
        <Button
          variant='contained'
          color='primary'
          size='small'
          disabled={disabled}
          className={classes.root}
          children={<Icon type='group-accept' fontSize='small' />}
          onClick={onClick}
        />
      </Tooltip>
    </>
  )
}